import { createSelector } from "@reduxjs/toolkit";
import { PreparedEntry } from "../Utils/Entry";
import { RootState } from "../Store/Store";

export const selectEntries = createSelector(
    [(state: RootState) => state.entries?.entries],
    entries => entries
)

export const selectEntriesByAwardId = createSelector(
    [
        (state: RootState, awardId: string) => state.entries.awardId,
        (state: RootState, awardId: string) => selectEntries(state),
        (state: RootState, awardId: string) => awardId,
    ],
    (stateAwardId, stateEntries, awardIdParam) => {
    // bail out if we dont have the awardId loaded
    if(""+stateAwardId !== ""+awardIdParam)
        return null;

    return stateEntries
        ?.filter((entry: PreparedEntry) => {
            return ""+entry.awardId === ""+awardIdParam;
        }) ?? null
    }
);
